import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';

const DigitalClockBlock = ({ city, timezone, currentTime }) => {
  // Format time as 24-hour
  const formatTime = (date, timezone) => {
    try {
      // 24-hour format
      return date.toLocaleTimeString('en-GB', { 
        hour: '2-digit', 
        minute: '2-digit',
        hour12: false,
        timeZone: timezone
      });
    } catch (error) {
      console.error(`Error formatting time for timezone ${timezone}:`, error);
      return '--:--';
    }
  };

  return (
    <div className="flex items-center justify-between mb-2">
      <div className="text-xs font-medium text-gray-400 mr-3 w-10 text-right">
        {city}
      </div>
      <div className="text-sm font-bold text-white bg-[#2a2a2a] px-3 py-1 rounded-md w-16 text-center">
        {formatTime(currentTime, timezone)}
      </div>
    </div>
  );
};

const DualTimezoneClock = () => {
  const [currentTime, setCurrentTime] = useState(new Date());
  
  // Update time every second
  useEffect(() => {
    const timer = setInterval(() => {
      setCurrentTime(new Date());
    }, 1000);
    
    return () => clearInterval(timer);
  }, []);
  
  return (
    <div className="space-y-2 py-2">
      <DigitalClockBlock 
        city="BCN" 
        timezone="Europe/Madrid" 
        currentTime={currentTime} 
      />
      <DigitalClockBlock 
        city="BOLO" 
        timezone="Europe/Rome" 
        currentTime={currentTime} 
      />
      <DigitalClockBlock 
        city="FL" 
        timezone="America/Chicago" 
        currentTime={currentTime} 
      />
    </div>
  );
};

DualTimezoneClock.propTypes = {
  // Keep prop types for backward compatibility
  primaryTimezone: PropTypes.string,
  secondaryTimezone: PropTypes.string
};

export default DualTimezoneClock; 